<script setup lang="ts">
import { inject, ref } from 'vue'
import { investmentProjectKey } from '@/symbols/listing'
import './_index.scss'

import type { InvestmentProject } from '@/server/api/buyer-front/types'

import { getDeliveryTermLabel } from '@/utils/project/index'

const listing = inject(investmentProjectKey) as InvestmentProject

const { t } = useI18n()

type opportunityStore = string | undefined

const opportunity: opportunityStore = listing.opportunity
const showMore = ref(false)

const opportunityFlter = (opportunity: opportunityStore) : number => {
  const opportunityText: string = opportunity !== undefined ? opportunity : ''
  const opportunityLength = opportunityText.length
  return opportunityLength
}

const toggleShowMore = () => {
  showMore.value = !showMore.value
}

const heightAdjustment = (show: boolean, opportunity: opportunityStore) => {
  const validateLength = opportunityFlter(opportunity) > 300
  if (validateLength && !show) {
    return true
  } else {
    showMore.value = true
    return false
  }
}

</script>

<script lang="ts">
export default {
  name: 'PdInvestmentPropertyDetails'
}
</script>

<template>
  <div class="pd-property-details py-16">
    <p class="mb-16 text-carbon-800 font-medium text-22 md:text-32">
      {{ t('title') }}
    </p>

    <div class="border-carbon-light-300">
      <p class="text-carbon-600 text-12  md:text-16">
        {{ t('deliveryfrom') }}:
      </p>

      <p class="text-carbon-800 text-18 font-semibold md:text-24 pt-4">
        {{ getDeliveryTermLabel(listing?.ims?.delivered_at, t, true) }}
      </p>
    </div>

    <div
      v-if="listing.opportunity"
      :class="showMore ? 'h-auto' : 'h-100'">
      <div class="pd-property-details__description relative overflow-hidden text-14 md:text-16 font-normal mb-8 mt-24">
        <p :class="heightAdjustment(showMore, opportunity) ? 'h-76' : 'h-auto'">
          {{ opportunity }}
        </p>

        <p :class="showMore ? '' : 'pd-property-details__last-line-opacity'" />
      </div>

      <ClientOnly>
        <button
          v-if="opportunityFlter(opportunity) > 300"
          id="pd-property-details-button-see-more"
          data-lh-id="pd-property-details-button-see-more"
          type="button"
          class="text-blue-500 text-16 text-primary-600 font-medium underline relative"
          :aria-label="showMore ? t('seeLess') : t('seeMore')"
          @click="toggleShowMore">
          {{ showMore ? t('seeLess') : t('seeMore') }}
        </button>
      </ClientOnly>
    </div>
  </div>
</template>

<i18n src="./i18n.json" lang="json"></i18n>
